import { render, staticRenderFns } from "./Step2InventoryList.vue?vue&type=template&id=f9457e24&"
import script from "./Step2InventoryList.vue?vue&type=script&lang=js&"
export * from "./Step2InventoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports